<template>
  <footer id="footer" class="text-white mt-auto py-5">
    <div class="container oversized-container">
      <div class="row mb-5">
        <!-- Company Info -->
        <div class="col-12 col-md-6 mb-4 mb-lg-0">
          <h3 class="footer-section-title font-weight-bold mb-4">DEC Industries</h3>
          <p class="text-light-50 mb-4 small">
            1445 North Loop West
            <br>
            242F #1392
            <br>
            Houston, TX 77008
          </p>

          
          <!-- <p class="text-light-50 mb-4 small">
            Your trusted source for premium engine parts. Serving the USA with quality and reliability.
          </p>
          <div class="d-flex align-items-center mb-2">
            <i class="fa-solid fa-phone mr-2"></i>
            <span class="small">1-800-DEC-PARTS</span>
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="fa-solid fa-envelope mr-2"></i>
            <span class="small">info@decindustries.us</span>
          </div> -->
        </div>

        <div class="col-12 col-md-6 mb-4 mb-lg-0 text-lg-right">
          <p class="text-light-50 mb-4 small">
            Your trusted source for premium engine parts. Serving the USA with quality and reliability.
          </p>
          <div class="d-flex align-items-center mb-2 justify-content-lg-end">
            <i class="fa-solid fa-phone mr-2"></i>
            <span class="small">1-800-DEC-PARTS</span>
          </div>
          <div class="d-flex align-items-center mb-2 justify-content-lg-end">
            <i class="fa-solid fa-envelope mr-2"></i>
            <span class="small">info@decindustries.us</span>
          </div>
        </div>

        <!-- Products -->
        <!-- <div class="col-6 col-lg-4 mb-4 mb-lg-0">
          <h3 class="footer-section-title font-weight-bold mb-4">Products</h3>
          <ul class="list-unstyled small">
            <li class="mb-2" v-for="(category, cInx) in categories" :key="'cInx-'+cInx">
              <router-link :to="'/products?k=&c='+category.id+'&b=&s=name&page=1'" class="footer-link">{{ category.name }}</router-link>
            </li>
          </ul>
        </div> -->

        <!-- Brands -->
        <!-- <div class="col-6 col-lg-4 mb-4 mb-lg-0">
          <h3 class="footer-section-title font-weight-bold mb-4">Brands</h3>
          <ul class="list-unstyled small">
            <li class="mb-2" v-for="(brand, bInx) in brands" :key="'bInx-'+bInx">
              <router-link :to="'/products?k=&c=&b='+brand.id+'&s=name&page=1'" class="footer-link">{{ brand.name }}</router-link>
            </li>
          </ul>
        </div> -->

        <!-- Customer Service -->
        <!-- <div class="col-12 col-md-6 col-lg-3">
          <h3 class="footer-section-title font-weight-bold mb-4">Customer Service</h3>
          <ul class="list-unstyled small">
            <li class="mb-2">
              <a href="#" class="footer-link">Track Order</a>
            </li>
            <li class="mb-2">
              <a href="#" class="footer-link">Shipping Info</a>
            </li>
            <li class="mb-2">
              <a href="#" class="footer-link">Returns</a>
            </li>
            <li class="mb-2">
              <a href="#" class="footer-link">Warranty</a>
            </li>
            <li class="mb-2">
              <a href="#" class="footer-link">Contact Us</a>
            </li>
          </ul>
        </div> -->
      </div>

      <div class="border-top footer-divider pt-4">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-light-50 small">
          <p class="mb-3 mb-md-0">© {{ currentYear }} DEC Industries Engine Parts. All rights reserved.</p>
          <div class="d-flex">
            <router-link href="#" class="footer-link mr-4" to="/privacy-policy">Privacy Policy</router-link>
            <router-link to="/terms-of-service" class="footer-link">Terms of Service</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      brands: [],
      categories: [],
      currentYear: new Date().getFullYear(),
    }
  },

  methods: {
    getFooterOptions() {
      axios.get(tools.url('/api/brands-categories')).then((response) => {
        this.brands = response.data.brands;
        this.categories = response.data.categories;
      });
    }
  },
  
  beforeMount() {
    this.getFooterOptions();
  }
}
</script>
